import { Navigate } from 'react-router';
import { useFeatureFlagsReady } from '@/hooks/use-feature-flags-ready';
import { useHomeRoute } from '@/hooks/use-home-route';
import { PageLoader } from './page-loader';

export function HomeRedirect() {
  const isReady = useFeatureFlagsReady();
  const homeRoute = useHomeRoute();

  if (!isReady) {
    return <PageLoader />;
  }

  return <Navigate to={homeRoute.slice(1)} replace />;
}
